

























































































































import VueElementLoading from "vue-element-loading"
import DragableMultiselect from "@/components/custom/DragableMultiselect.vue";
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ReportCashExecRow } from "../table-data/ReportCashExecRow"
import { Classificator } from "../../../common/types/Classificator"
import { Indicator } from "../../../common/types/Indicator"
import { ClassificationType } from "../../../common/types/roots/fields"
import { formatDigitsGrouping } from "../../../common/utils/formattingUtils"
import { cloneDeep } from "lodash"
import moment from "moment"

type Column = keyof ReportCashExecRow

interface TableField {
    key: string
    label: string
    active: boolean
    child_list: TableField[]
    parent: TableField | null
    colspan: number
    rowspan: number
}

const incomeParentHeaders: any = {
    "plan": false,
    "plan_utch_year": "utch_budget",
    "plan_utch_month": "utch_budget",
    "plan_corr_year": "scor_plan_rep",
    "plan_corr_month": "scor_plan_rep",
    "month_sum": "scor_plan_rep",
    "sumrg": "cash_execution",
    "exec_cash_curr_month": "cash_execution",
    "delta_sumrg": "cash_execution",
    "remain_year": "remainder",
    "remain_period": "remainder",
    "remaind_month": "remainder",
    "exec_pct_year": "execution_rate",
    "exec_pct_period": "execution_rate",
    "exec_pct_month": "execution_rate",
    "sumrg_past_year": "on_repdate",
    "growth_rate": "on_repdate",
    "dev_from_past": "on_repdate",
    "month_rate": false
}

const expenseParentHeaders:any = {
    "plan_plat": false,
    "utch_budget_rep_year": "utch_budget",
    "utch_budget_rep_month": "utch_budget",
    "scor_plan_rep_year": "scor_plan_rep",
    "scor_plan_rep_month": "scor_plan_rep",
    "month_sum_plat": "scor_plan_rep",
    "sumrg": "cash_execution",
    "curr_sumrg": "cash_execution",
    "delta_sumrg": "cash_execution",
    "reaminder_plan_rep_year": "remainder_payment",
    "remainder_plan_rep_period": "remainder_payment",
    "execution_rate_year": "payment_execution_rate",
    "execution_rate_period": "payment_execution_rate",
    "period_sum_obaz": "scor_plan_obligations",
    "month_sum_obaz": "scor_plan_obligations",
    "registrob": false,
    "remainder_obaz_year": "ramainder_obligations",
    "remainder_payment_cur_per": "ramainder_obligations",
    "execution_obaz_year": "obligations_execution_rate",
    "execution_rate_obaz_cur_year": "obligations_execution_rate",
    "sumrg_past": "on_repdate",
    "increase_rate": "on_repdate",
    "deviation_cur_year": "on_repdate"
}

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading,
        'dragable-multiselect': DragableMultiselect,
    }
})
export default class ReportCashExec extends Vue {

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    public readonly tableData!: ReportCashExecRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propIndicators!: Indicator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly incomes!: Classificator[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly expenses!: Classificator[]

    @Prop({
        type: String,
        required: true,
    })
    private readonly classificationType!: ClassificationType

    @Prop({
        type: Date,
        required: true,
        default: new Date(),
    })
    private readonly date!: Date

    @Prop({
        type: Boolean,
        required: true,
        default: false,
    })
    private readonly isTree!: boolean

    @Prop({
        type: Boolean,
        required: false,
        default: false,
    })
    private readonly nameBeforeKbk!: boolean

    public tableFields: TableField[] = []
    public classifications: string[] = []
    public indicators: Indicator[] = []
    public child_fields: TableField[] = []

    public currentPage = 1
    public get visibleRows() {
        return this.tableData.filter(it => it.visible).length
    }
    public get currentItems(): ReportCashExecRow[] {
        if (this.isTree) {
            return this.tableData.filter(it => it.visible)
        } else {
            const indexedPage = this.currentPage - 1
            const startIndex = indexedPage * 10
            const endIndex = startIndex + 10
            return this.tableData.filter(it => it.visible).slice(startIndex, endIndex)
        }
    }

    private created() {
        this.indicators = cloneDeep(this.propIndicators)
        this.constructTableFields(true)
        this.handlePageChange(1)
    }

    private constructTableFields(isOnCreate: boolean) {
        // Классификаций
        let activeClassifications:string[] = ['action']
        // «Наименование перед КБК» действует только в древовидном режиме
        const nameBeforeKbk = this.isTree && this.nameBeforeKbk
        if (nameBeforeKbk) {
            activeClassifications.push('name')
        }
        if (this.isTree) {
            let classifications: Classificator[] = []
            if (this.classificationType === 'INCOMES') {
                classifications = cloneDeep(this.incomes)
            } else if (this.classificationType === 'EXPENSES') {
                classifications = cloneDeep(this.expenses)
            } else {
                throw new Error('error_type_classification')
            }
            this.classifications = classifications.filter(it => it.active).map(it => it.key)
            activeClassifications = activeClassifications.concat(this.classifications)
        }
        if (!nameBeforeKbk) {
            activeClassifications.push('name')
        }

        // Показатели
        const indicators = cloneDeep(isOnCreate ? this.propIndicators : this.indicators)


        // Родительские колонки
        const activeIndicators = activeClassifications.concat(indicators.filter(it => it.active).map(it => it.key))
        if (this.classificationType === 'INCOMES') {
            this.tableFields = this.constructParentIndicators(activeIndicators, incomeParentHeaders)
        } else {
            this.tableFields = this.constructParentIndicators(activeIndicators, expenseParentHeaders)
        }

    }

    private constructParentIndicators(activeIndicators: string[], headersDict: any): TableField[] {
        const tree: Record<string, TableField> = {}
        let parentNode: TableField | null = null
        for (const ind of activeIndicators) {
            const child: TableField = {
                key: ind,
                label: ind,
                active: true,
                child_list: [],
                parent: null,
                colspan: 1,
                rowspan: 1
            }
            if (headersDict[ind]) {
                parentNode = tree[headersDict[ind]]
                if (!parentNode) {
                    parentNode = {
                        key: headersDict[ind],
                        label: headersDict[ind].replace(`__${ind}`, ''),
                        active: true,
                        child_list: [],
                        parent: null,
                        colspan: 0,
                        rowspan: 1
                    }
                    tree[headersDict[ind]] = parentNode
                }
                child.parent = parentNode
                parentNode.child_list.push(child)
                parentNode.colspan++
            } else {
                child.rowspan = 2
                tree[ind] = child
            }
        }
        const tableFields: TableField[] = Object.values(tree)
        for (const node of tableFields) {
            if (node.child_list.length === 1) {
                node.label = node.child_list[0].label + '_full'
                node.rowspan = 2
                node.child_list.splice(0)
            }
        }
        return tableFields
    }
    private separateOrJoinChild(field: TableField) {
        const childKey = field.label.replace('_full', '')
        let headersDict: any = expenseParentHeaders
        if (this.classificationType === 'INCOMES') {
            headersDict = incomeParentHeaders
        }
        const separate: boolean = !headersDict[childKey]?.includes(`__${childKey}`)
        if (separate && childKey in headersDict) {
            headersDict[childKey] = `${headersDict[childKey]}__${childKey}`
        } else if ((!separate) && childKey in headersDict) {
            headersDict[childKey] = headersDict[childKey].replace(`__${childKey}`, '')
        }
        this.constructTableFields(false)
    }

    public handlePageChange(page: number) {
        this.currentPage = page
    }

    public tr(key: any): string | null {
        if (typeof key !== 'string') {
            return null
        }

        let text = ''
        let tableTranslationKey = ''
        if (this.classificationType === 'INCOMES') {
            tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.cash_execution_report.2_19.table'
        } else if (this.classificationType === 'EXPENSES') {
            tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.cash_execution_report.4_20.table'
        }
        text = this.$t(`${tableTranslationKey}.${key}`).toString()

        if (!text || text === `${tableTranslationKey}.${key}`) {

            const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
            text = this.$t(`${translationKey}.${key}`).toString()

            if (!text || text === `${translationKey}.${key}`) {
                text = key
            }
        }

        if (text.includes('$date')) {
            const date = moment(this.date)
            const days = date.year() % 4 === 0 ? 366 : 365
            const previousYearDate = date.subtract(days, 'days')
            const formattedPreviousYearDate = previousYearDate.format('DD.MM.YYYY')
            text = text.replaceAll("$date", formattedPreviousYearDate)
        }

        return text
    }
    public indictorCustomnLabel(indicator: Indicator) {
        return this.tr(indicator.key + '_full')
    }
    public checkMove(evt: any) {
        const dragged: any = evt.draggedContext.element
        const related: any | undefined = evt.relatedContext?.element
        // 🔒 Разрешаем только если parent совпадает
        if ([dragged?.parent?.key, related?.parent?.key].includes(undefined)) {
            const p_dragged = evt?.dragged?.attributes?.parent_element?.value
            const p_related = evt?.related?.attributes?.parent_element?.value
            if ([p_dragged, p_related].includes(undefined)) {
                return true
            }
            return p_dragged === p_related || true
        }
        return dragged?.parent?.key === related?.parent?.key || true
    }
    public synchronizeIndicatorsOrderByParent() {
        this.synchronizeIndicatorsOrder()
        this.constructTableFields(false)
    }

    public synchronizeIndicatorsOrder() {
        const fullIndicatorKeys = this.indicators.map(v => v.key)
        const indicatorsOrder:string[] = []
        for (const parent of this.tableFields) {
            let key = ''
            if (parent.child_list && parent.child_list.length > 0) {
                for (const child of parent.child_list) {
                    key = child.label
                }
            } else {
                key = parent.label
            }
            key = key.replace('_full', '')
            if (fullIndicatorKeys.includes(key)) {
                indicatorsOrder.push(key)
            }
        }
        fullIndicatorKeys.forEach(indicatorKey => {
            if (indicatorsOrder.notIncludes(indicatorKey)) {
                indicatorsOrder.push(indicatorKey)
            }
        })

        const tempIndicators: Indicator[] = []
        indicatorsOrder.forEach(indicatorKey => {
            const IndicatorObject = this.indicators.find(it => it.key === indicatorKey)!
            tempIndicators.push(IndicatorObject)
        })
        this.indicators = tempIndicators
        this.$emit('update-indicators', tempIndicators)
    }

    public synchronizeVisiblityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.constructTableFields(false)
    }

    public format(value: any): any {
        if (value == null) {
            return ''
        }
        if (Number(value).isNaN) {
            return value
        }
        return formatDigitsGrouping(value)
    }

    public tableCollapse = true
    public collapse(idx:number, collapse:boolean, collapseAll:boolean = false) {
        const el:ReportCashExecRow = this.tableData[idx]
        if (el.hasChild) {
            for (const ch of this.tableData.slice(idx + 1)) {
                if (ch.parent_idx === idx) {
                    ch.visible = !collapse
                    if (collapse || collapseAll) {
                        this.collapse(ch['idx'], collapse, collapseAll)
                        ch.collapse = collapse
                    }
                }

            }
        }
        el.collapse = collapse
    }
    public collapseAll(collapse:boolean) {
        for (const item of this.tableData) {
            if (item.parent_idx === null && item.hasChild) {
                item.collapse = collapse
                this.collapse(item.idx, collapse, true)
            }
        }
        this.tableCollapse = collapse
    }
}
